import { useState, useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
    Box, Button, ButtonGroup, Card, CardContent, CardHeader, Chip,
    CircularProgress,
    Grid2 as Grid,
    Tooltip,
} from '@mui/material';
import { AccountCircle, Add, Cancel, Check, CleanHands, ClearAll, Delete, Download, Edit} from '@mui/icons-material';
import { checkComponentPresence } from "../utils/ui_utils";

import DeleteconfirmationSection from "../components/DeleteConfirmationSection";
import { delete_category_template, get_category_template_list } from "../FirebaseUtils/dbSettings"
import { useEvent } from "../context/eventContext";
import { useAuth } from "../core/AuthProvider";
import { TemplateCategoryDialog } from "../modals/TemplateCategoryDialog";

export const TemplateCategorySection = () => {

    const dialogRef = useRef()
    const { user } = useAuth()
    const childRefDelete = useRef()
    const { selEvent } = useEvent()
    const [element_list, setElementList] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const handleNew = () => {
        dialogRef.current.onNew()
    }

    const handleEdit = (r, i) => {
        dialogRef.current.onEdit(r, i)
    }

    const handleDelete = (r, i) => {
        const cb = () => {
            delete_category_template(user.uid, r.id)
            setElementList(lst => {
                let _el = [...lst]
                _el.splice(i, 1)
                return _el
            })
        }
        childRefDelete.current.confirmDelete('Cancella Template categorie', `Sei sicuro di voler cancellare il template categorie: <b>${r.name}</b>`, cb)
    }


    const reloadFn = async (el) => {
        setIsLoading(true)
        if (el) {
            setElementList(lst => {
                const c = checkComponentPresence(el, element_list, 'id')
                let _el = [...lst]
                if (c >= 0) {
                    _el.splice(c, 1, el)
                }
                return _el

            })


        } else {
            const data = await get_category_template_list()
            setElementList(data)

        }
    }



    useEffect(() => {
        console.log(selEvent.id)
        reloadFn()
    }, [selEvent])


    useEffect(() => {
        if (element_list.length > 0) {
        }
        console.log("------element list", element_list.length)
        setIsLoading(false)

    }, [element_list])



    return (
        <Box sx={{ textAlign: 'center', p: 1 }}>

            <DeleteconfirmationSection ref={childRefDelete} />
            <TemplateCategoryDialog ref={dialogRef} reloadFn={reloadFn} event_id={selEvent.id} />
            {isLoading ?
                <CircularProgress />
                :
                <Card sx={{ border: '1px solid lightblue', mt: 1 }}>
                    <CardContent>
                        <Grid container spacing={2} sx={{ background: 'lightblue', p: 0.5, borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                            <Grid size={"grow"} sx={{ fontSize: '1.2em', fontWeight: 'bold', textAlign: 'left' }}>
                                Lista template categorie
                            </Grid>
                            <Grid size={"auto"} sx={{ textAlign: 'right' }}>
                                <Button onClick={handleNew} variant="contained" size="small" startIcon={<Add />}>nuovo template </Button>
                            </Grid>
                        </Grid>

                        {element_list?.length > 0 ?
                            <>
                                <Grid container sx={{ backgroundColor: 'lightgrey' }}>
                                    <Grid size="grow">
                                        nome
                                    </Grid>
                                    <Grid size={3} sx={{ textAlign: 'right' }}>
                                    </Grid>

                                </Grid>

                                <Grid >
                                    {element_list.map((s, k) => (
                                        <OneTemplate_category
                                            key={k}
                                            template_category={s}
                                            index={k}
                                            handleEdit={handleEdit}
                                            handleDelete={handleDelete}
                                        />
                                    ))}
                                </Grid>
                            </>
                            :
                            <Grid >
                                Nessun soggetto ancora inserito
                            </Grid>
                        }
                    </CardContent>
                </Card>
            }

        </Box >
    );
}



const OneTemplate_category = ({ template_category, index, handleDelete, handleEdit }) => {

    return (
        <Grid container sx={{ borderTop: '1px solid black', pt: 1, mt: 1 }}>
            <Grid size={"grow"}>
                {template_category.name}
            </Grid>
            <Grid size={3} sx={{ textAlign: 'right' }}>
                <ButtonGroup size="small">
                    <Tooltip title="modifica">
                        <Button color="warning" onClick={() => handleEdit(template_category, index)} startIcon={<Edit color="warning" />}></Button>
                    </Tooltip>
                    <Tooltip title="cancella">
                        <Button color="error" onClick={() => handleDelete(template_category, index)} startIcon={<Delete />}></Button>
                    </Tooltip>
                </ButtonGroup>

            </Grid>
        </Grid>

    )
}


